import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const FileIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.6", ...props.sx}} viewBox="0 0 18 18">
        <path
            d="M10.6001 1H4.2001C3.77575 1 3.36878 1.16857 3.06873 1.46863C2.76867 1.76869 2.6001 2.17565 2.6001 2.6V15.4C2.6001 15.8243 2.76867 16.2313 3.06873 16.5314C3.36878 16.8314 3.77575 17 4.2001 17H13.8001C14.2244 17 14.6314 16.8314 14.9315 16.5314C15.2315 16.2313 15.4001 15.8243 15.4001 15.4V5.8M10.6001 1L15.4001 5.8M10.6001 1V5.8H15.4001M12.2001 9.8H5.8001M12.2001 13H5.8001M7.4001 6.6H5.8001"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
